import { render, staticRenderFns } from "./IncubatorView.vue?vue&type=template&id=3671d424&scoped=true&"
import script from "./IncubatorView.vue?vue&type=script&lang=js&"
export * from "./IncubatorView.vue?vue&type=script&lang=js&"
import style0 from "./IncubatorView.vue?vue&type=style&index=0&id=3671d424&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3671d424",
  null
  
)

export default component.exports